import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import CardAdPriceIndicator from './CardAdPriceIndicator/index.js'
import {CardAdPricePriceDrop} from './card-ad-price-price-drop.js'
import {getVerticalClass} from './utils.js'

const _getCashFooterClass = hasTaxes => {
  return cx('mt-CardAdPrice-cashFooter', {
    'mt-CardAdPrice-cashFooter--withTaxes': hasTaxes,
    'mt-CardAdPrice-cashFooter--withoutTaxes': !hasTaxes
  })
}

const CARD_ROLE = `card-adPrice`
const PRICE_TEST_ID = `${CARD_ROLE}-price`

export const CardAdPriceCash = ({
  forcedShowPriceIndicator,
  isGridLayout = false,
  vertical,
  isExtended,
  price,
  priceRankIndicator,
  priceDropData,
  showPriceInfo,
  includesTaxes,
  taxType
}) => {
  const hasPriceIndicator = Boolean(priceRankIndicator)

  const {i18n, domain} = useContext(Context)

  const config = domain.get('config')
  const {SHOW_TAXES} = config.get('search')

  const showPriceIndicator = !isExtended && (hasPriceIndicator || forcedShowPriceIndicator)

  const showPriceDrop = Boolean(priceDropData)

  const mainPrice = price

  return (
    <div
      className={getVerticalClass({
        className: 'mt-CardAdPrice-cash',
        isVertical: vertical && isExtended
      })}
    >
      {showPriceIndicator ? (
        <CardAdPriceIndicator rank={priceRankIndicator} withIcon={false} />
      ) : (
        <span className="mt-CardAdPrice-cashLabel">{i18n.t(isGridLayout ? 'COMMON_CASH' : 'CARD_AD_CASH')}</span>
      )}
      <p className="mt-CardAdPrice-cashAmount" data-testid={PRICE_TEST_ID}>
        {i18n.c(mainPrice)}
      </p>

      {isExtended && showPriceDrop && <CardAdPricePriceDrop priceDropData={priceDropData} />}

      {isExtended && showPriceInfo && taxType && SHOW_TAXES && (
        <span className={_getCashFooterClass(includesTaxes)}>{taxType}</span>
      )}
    </div>
  )
}

CardAdPriceCash.propTypes = {
  forcedShowPriceIndicator: PropTypes.bool,
  includesTaxes: PropTypes.bool,
  isExtended: PropTypes.bool,
  isGridLayout: PropTypes.bool,
  price: PropTypes.number,
  priceDropData: PropTypes.object,
  priceRankIndicator: PropTypes.number,
  showPriceInfo: PropTypes.bool,
  taxType: PropTypes.string,
  vertical: PropTypes.bool
}
